export function FontSizeLargerIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 36 36" className={className}>
      <path
        d="M26.7803 10.2803C26.921 10.1397 27 9.94891 27 9.75C27 9.55109 26.921 9.36032 26.7803 9.21967C26.6397 9.07902 26.4489 9 26.25 9H9.75C9.55109 9 9.36032 9.07902 9.21967 9.21967C9.07902 9.36032 9 9.55109 9 9.75C9 9.94891 9.07902 10.1397 9.21967 10.2803C9.36032 10.421 9.55109 10.5 9.75 10.5H26.25C26.4489 10.5 26.6397 10.421 26.7803 10.2803Z"
        fill="currentColor"
      />
      <path
        d="M21.7803 27.7803C21.921 27.6397 22 27.4489 22 27.25C22 27.0511 21.921 26.8603 21.7803 26.7197C21.6397 26.579 21.4489 26.5 21.25 26.5H14.75C14.5511 26.5 14.3603 26.579 14.2197 26.7197C14.079 26.8603 14 27.0511 14 27.25C14 27.4489 14.079 27.6397 14.2197 27.7803C14.3603 27.921 14.5511 28 14.75 28H21.25C21.4489 28 21.6397 27.921 21.7803 27.7803Z"
        fill="currentColor"
      />
      <path
        d="M17.4697 27.7803C17.6103 27.921 17.8011 28 18 28C18.1989 28 18.3897 27.921 18.5303 27.7803C18.671 27.6397 18.75 27.4489 18.75 27.25L18.75 9.75C18.75 9.55109 18.671 9.36032 18.5303 9.21967C18.3897 9.07902 18.1989 9 18 9C17.8011 9 17.6103 9.07902 17.4697 9.21967C17.329 9.36032 17.25 9.55109 17.25 9.75L17.25 27.25C17.25 27.4489 17.329 27.6397 17.4697 27.7803Z"
        fill="currentColor"
      />
      <path
        d="M9.21967 12.7803C9.36032 12.921 9.55109 13 9.75 13C9.94891 13 10.1397 12.921 10.2803 12.7803C10.421 12.6397 10.5 12.4489 10.5 12.25L10.5 9.75C10.5 9.55109 10.421 9.36032 10.2803 9.21967C10.1397 9.07902 9.94891 9 9.75 9C9.55109 9 9.36032 9.07902 9.21967 9.21967C9.07902 9.36032 9 9.55109 9 9.75L9 12.25C9 12.4489 9.07902 12.6397 9.21967 12.7803Z"
        fill="currentColor"
      />
      <path
        d="M25.7197 12.7803C25.8603 12.921 26.0511 13 26.25 13C26.4489 13 26.6397 12.921 26.7803 12.7803C26.921 12.6397 27 12.4489 27 12.25L27 9.75C27 9.55109 26.921 9.36032 26.7803 9.21967C26.6397 9.07902 26.4489 9 26.25 9C26.0511 9 25.8603 9.07902 25.7197 9.21967C25.579 9.36032 25.5 9.55109 25.5 9.75L25.5 12.25C25.5 12.4489 25.579 12.6397 25.7197 12.7803Z"
        fill="currentColor"
      />
    </svg>
  )
}
